import React, { useState, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./index.css";
import section2img from "../assests/HomeImg/section2-img.svg";

// ── Shareholding Pattern Imports ───────────────────────────────────────────

import shp_111 from "../assests/shareholder/Shareholding-Pattern (1).pdf";
import shp_111a from "../assests/shareholder/Shareholding-Pattern-q4-26.pdf";
import shp_112 from "../assests/shareholder/Website-SHP-PDF.pdf";
import shp_113 from "../assests/shareholder/SHP-31032025-PDF.pdf";
import shp_114 from "../assests/shareholder/SHP-Q4-14042025.pdf";
import shp_115 from "../assests/shareholder/SHP-31122024.pdf";
import shp_116 from "../assests/shareholder/SHP30092024.pdf";
import shp_117 from "../assests/shareholder/SHP30062024 wesbite.pdf";
import shp_118 from "../assests/shareholder/Quarter ended 1.pdf";
import shp_119 from "../assests/shareholder/Quarter ended 2.pdf";
import shp_120 from "../assests/shareholder/Quarter ended 3.pdf";
import shp_121 from "../assests/shareholder/Shareholding Pattern on March 31, 2024.pdf";
import shp_122 from "../assests/shareholder/SHP_Q1.pdf";
import shp_123 from "../assests/shareholder/SESHP-Q2.pdf";
import shp_124 from "../assests/shareholder/SHPQ3.pdf";
import shp_125 from "../assests/shareholder/SHP-March.pdf";
import shp_126 from "../assests/shareholder/Quarter Ended 1 (1).pdf";
import shp_127 from "../assests/shareholder/Quarter Ended 2 (1).pdf";
import shp_128 from "../assests/shareholder/Shareholding pattern_31.12.2021.pdf";
import shp_129 from "../assests/shareholder/SSL_SHP_31-03-2022.pdf";
import shp_130 from "../assests/shareholder/Shareholding Pattern - 30.06.2020.html.pdf";
import shp_131 from "../assests/shareholder/Shareholding Pattern - SSL - 30.09.2020.pdf";
import shp_132 from "../assests/shareholder/Shareholding Pattern - SSL - 31.03.2020_Q3.pdf";
import shp_133 from "../assests/shareholder/Shareholding Pattern_March 31, 2021_Q4.pdf";
import shp_134 from "../assests/shareholder/190708181021_0001.pdf";
import shp_135 from "../assests/shareholder/SHP.pdf";
import shp_136 from "../assests/shareholder/Shareholding Pattern - SSL - 31.12.2019.pdf";
import shp_137 from "../assests/shareholder/Shareholding Pattern - SSL - 31.03.2020.pdf";
import shp_138 from "../assests/shareholder/Shareholding_patterns_as_on_June_30__2018.pdf";
import shp_139 from "../assests/shareholder/Shareholding_Pattern.pdf";
import shp_140 from "../assests/shareholder/190115115453_0001.pdf";
import shp_141 from "../assests/shareholder/SHP (1).pdf";
import shp_142 from "../assests/shareholder/SHP_Signed-_30_06_2017.pdf";
import shp_143 from "../assests/shareholder/Shareholding_Pattern_-_30.09.2017.pdf";
import shp_144 from "../assests/shareholder/Final_SHP.pdf";
import shp_145 from "../assests/shareholder/SHP Q4 2017 2018.pdf";
import shp_146 from "../assests/shareholder/Sequent_Shareholding Pattern_June 30_2016.pdf";
import shp_147 from "../assests/shareholder/Sequent_Shareholding Pattern_Reg31(1)(b)_September 30 2016.pdf";
import shp_148 from "../assests/shareholder/Sequent_Regulation 31(1)(b)_December 31, 2016.pdf";
import shp_149 from "../assests/shareholder/SHP as of 31.03.2017.pdf";
import shp_150 from "../assests/shareholder/Sequent_Clause 35_June 30, 2015.pdf";
import shp_151 from "../assests/shareholder/Q2_SHP_September 30, 2015.pdf";
import shp_152 from "../assests/shareholder/Sequent_Shareholding Pattern_December 31, 2015.pdf";
import shp_153 from "../assests/shareholder/Sequent_Regulation 31(1)(b)_March 31, 2016.pdf";
import shp_154 from "../assests/shareholder/Q1-June-30-2014.pdf";
import shp_155 from "../assests/shareholder/Q2-Sep-30-2014.pdf";
import shp_156 from "../assests/shareholder/Q3-Dec-31-2014.pdf";
import shp_157 from "../assests/shareholder/Q4_March 31, 2015.pdf";
import shp_158 from "../assests/shareholder/Q1_June 30, 2013.pdf";
import shp_159 from "../assests/shareholder/Q2_September 30, 2013.pdf";
import shp_160 from "../assests/shareholder/Shareholding Pattern_Q3.pdf";
import shp_161 from "../assests/shareholder/Q4_March31, 2014.pdf";
import shp_162 from "../assests/shareholder/1_Q1_June 30, 2012.pdf";
import shp_163 from "../assests/shareholder/2_Q2_Sep 30, 2012.pdf";
import shp_164 from "../assests/shareholder/3_Q3-Dec 31, 2012.pdf";
import shp_165 from "../assests/shareholder/4_Q4-Mar 31, 2013.pdf";
import shp_166 from "../assests/shareholder/1_Q1_June 30, 2011.pdf";
import shp_167 from "../assests/shareholder/2_Q2_Sep 30, 2011.pdf";
import shp_168 from "../assests/shareholder/3_Q3_Dec 31, 2011.pdf";
import shp_169 from "../assests/shareholder/4_Q4_March 31, 2012.pdf";


import shp_2627_q1 from "../assests/shareholder/SHP Q1 FY27.pdf";
import shp_2627_q2 from "../assests/shareholder/SHP Q2 FY27.pdf";

// ── Archive Imports ────────────────────────────────────────────────────────
import arch_237 from "../assests/archives/June 30, 2023.pdf";
import arch_238 from "../assests/archives/September 30, 2023.pdf";
import arch_239 from "../assests/archives/News-Advertisement-30-August-2023.pdf";
import arch_240 from "../assests/archives/SE_Intimation_Newspaper_AD.pdf";
import arch_241 from "../assests/archives/September 30, 2020.pdf";
import arch_242 from "../assests/archives/May2019Advtersiment.pdf";
import arch_243 from "../assests/archives/NSEBSENewspaper.pdf";
import arch_244 from "../assests/archives/November 13, 2019.pdf";
import arch_245 from "../assests/archives/January 28, 2020.pdf";
import arch_246 from "../assests/archives/May_24__2018.pdf";
import arch_247 from "../assests/archives/NewspaperAD.pdf";
import arch_248 from "../assests/archives/News_Paper_Clippings.pdf";
import arch_249 from "../assests/archives/Attachement.pdf";
import arch_251 from "../assests/archives/AGM_2017_Advertisement.pdf";
import arch_252 from "../assests/archives/NSEBSENewspaperAdvertisement.pdf";
import arch_253 from "../assests/archives/May_23_2017.pdf";
import arch_254 from "../assests/archives/August_5_2017.pdf";
import arch_255 from "../assests/archives/Advertisement_November_9__2017.pdf";
import arch_256 from "../assests/archives/newspaper_Clipping.pdf";
import arch_257 from "../assests/archives/Sequent-Notice-FPJ-07thMay-pg14_NS-07thMay-pg12.jpg";
import arch_258 from "../assests/archives/Sequent-Notice-NS_N_FPJAugust_12_2016.jpg";
import arch_259 from "../assests/archives/Sequent-Notice-29thOct-NS-FPJ.pdf";
import arch_260 from "../assests/archives/Board Meeting February 10, 2017.pdf";
import arch_261 from "../assests/archives/Sequent-Notice-FPJ-February5_2016-scaled.jpg";
import arch_262 from "../assests/archives/Sequent-Notice-NS-FPJ-01stSEP.jpg";
import arch_263 from "../assests/archives/Sequent-Notice-NS-scaled.jpg";
import arch_264 from "../assests/archives/EGM_Advertisements-scaled.jpg";

// ── Downloads & MOA Imports ───────────────────────────────────────────────
import down_isr4 from "../assests/DownloadsPdf/Form-ISR-4.pdf";
import down_isr5 from "../assests/DownloadsPdf/Form-ISR-5.pdf";
import down_isr1 from "../assests/DownloadsPdf/Form ISR-1_p.pdf";
import down_isr2 from "../assests/DownloadsPdf/Form-ISR-2.pdf";
import down_isr3 from "../assests/DownloadsPdf/Form-ISR-3.pdf";
import down_sh13 from "../assests/DownloadsPdf/Form-SH-13.pdf";
import down_sh14 from "../assests/DownloadsPdf/Nominee-Form-SH-14.pdf";
import moa_1 from "../assests/DownloadsPdf/MOA-1.pdf";
import aoa_1 from "../assests/DownloadsPdf/aoa-1.pdf";

import Dividendnew1 from "../assests/Dividend/unclaimed-dividendnew1.pdf";
import Dividend1 from "../assests/Dividend/unclaimed-dividend1.pdf";

import Dividend2 from "../assests/Dividend/unclaimed-dividend2.pdf";
import Dividend3 from "../assests/Dividend/unclaimed-dividend3.pdf";
import Dividend4 from "../assests/Dividend/unclaimed-dividend4.pdf";
import Dividend5 from "../assests/Dividend/unclaimed-dividend5.pdf";
import Dividend6 from "../assests/Dividend/unclaimed-dividend6.pdf";
import Dividend7 from "../assests/Dividend/unclaimed-dividend7.pdf";
import Dividend8 from "../assests/Dividend/unclaimed-dividend8.pdf";
import Dividend9 from "../assests/Dividend/unclaimed-dividend9.pdf";
import Dividend10 from "../assests/Dividend/unclaimed-dividend10.pdf";
import Dividend11 from "../assests/Dividend/unclaimed-dividend11.pdf";
import Dividend12 from "../assests/Dividend/unclaimed-dividend12.pdf";
import Dividend13 from "../assests/Dividend/unclaimed-dividend13.pdf";
import Dividend14 from "../assests/Dividend/unclaimed-dividend14.pdf";
import Dividend15 from "../assests/Dividend/unclaimed-dividend15.pdf";
import Dividend16 from "../assests/Dividend/unclaimed-dividend16.pdf";
import Dividend17 from "../assests/Dividend/unclaimed-dividend17.pdf";
import Dividend18 from "../assests/Dividend/unclaimed-dividend18.pdf";
import Dividend19 from "../assests/Dividend/unclaimed-dividend19.pdf";
import Dividend20 from "../assests/Dividend/unclaimed-dividend20.pdf";
import Dividend21 from "../assests/Dividend/unclaimed-dividend21.pdf";
import Dividend22 from "../assests/Dividend/unclaimed-dividend22.pdf";
import Dividend23 from "../assests/Dividend/unclaimed-dividend23.pdf";
import Dividend24 from "../assests/Dividend/unclaimed-dividend24.pdf";
import Dividend25 from "../assests/Dividend/unclaimed-dividend25.pdf";
import Dividend26 from "../assests/Dividend/unclaimed-dividend26.pdf";
import Dividend27 from "../assests/Dividend/unclaimed-dividend27.pdf";
import Dividend28 from "../assests/Dividend/unclaimed-dividend28.pdf";
import Dividend29 from "../assests/Dividend/unclaimed-dividend29.pdf";
import Dividend30 from "../assests/Dividend/unclaimed-dividend30.pdf";
import Dividend31 from "../assests/Dividend/unclaimed-dividend31.pdf";
import Dividend32 from "../assests/Dividend/unclaimed-dividend32.pdf";
import Dividend33 from "../assests/Dividend/unclaimed-dividend33.pdf";


// Business Update & Merger Notices PDFs
import BU_Q3_25_26 from '../assests/aboutImages/BusinessUpdate/Q3 FY 2025-26.pdf';
import BU_Q2_25_26 from '../assests/aboutImages/BusinessUpdate/Q2 FY 2025-26.pdf';
import BU_Q1_25_26 from '../assests/aboutImages/BusinessUpdate/Q1 FY 2025-26.pdf';
import BU_Q4_24_25 from '../assests/aboutImages/BusinessUpdate/Q4 FY 2024-25.pdf';
import BU_Q3_24_25 from '../assests/aboutImages/BusinessUpdate/Q3 FY 2024-25.pdf';
import BU_Q2_24_25 from '../assests/aboutImages/BusinessUpdate/Q2 FY 2024-25.pdf';

import Merger_Index_1 from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Viyash-E-Shareholders.pdf';
import Merger_Index_2 from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Viyash-UTC.pdf';
import Merger_Index_3 from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Appcure-Labs-UTC.pdf';
import Merger_Index_4 from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Symed-Labs-UTC.pdf';
import Merger_Index_5 from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Geninn-E-Shareholders.pdf';
import Merger_Signed_1 from '../assests/aboutImages/MergerNoticesIndex/Signed-Symed-Final-UTC-Notice-28-07-2025.pdf';
import Merger_Signed_2 from '../assests/aboutImages/MergerNoticesIndex/Signed-Appcure-Final-UTC-Notice-28-07-2025.pdf';
import Merger_Signed_3 from '../assests/aboutImages/MergerNoticesIndex/Signed-Viyash-Final-EGM-Notice-8-07-2025.pdf';
import Merger_Signed_4 from '../assests/aboutImages/MergerNoticesIndex/Signed-Viyash-Final-UTC-Notice-28-07-2025.pdf';
import Merger_Signed_5 from '../assests/aboutImages/MergerNoticesIndex/Signed-Geninn-final-EGM-Notice-28-07-2025.pdf';

// ── SVG Icons ────────────────────────────────────────────────────────────────
const PdfIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 2V8H20" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 13H15" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
        <path d="M9 17H12" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const DownloadIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const FilterIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path d="M22 3H2l8 9.46V19l4 2V12.46L22 3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" strokeWidth="2" />
        <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" strokeWidth="2" />
    </svg>
);

// ── Tab data ───────────────────────────────────────────────────────────────────

const SharePriceData = [
    { title: "BSE", period: "", icon: <PdfIcon />, url: "https://www.bseindia.com/stock-share-price/sequent-scientific-ltd/sequent/512529/" },
    { title: "NSE", period: "", icon: <PdfIcon />, url: "https://www.nseindia.com/get-quote/equity/VIYASH/Viyash-Scientific-Limited" },
];

const CreditRatingLongTerm = [
    { year: "2023-24", agency: "Ind-Ra", rating: "IND A with negative outlook" },
    { year: "2024-25", agency: "Ind-Ra", rating: "IND A with Positive outlook" },
    { year: "2025-26", agency: "Ind-Ra", rating: "IND A with Positive outlook" },
    { year: "2026-27", agency: "ICRA", rating: "ICRA AA- with Stable outlook" },
];

const CreditRatingShortTerm = [
    { year: "2023-24", agency: "Ind-Ra", rating: "A1" },
    { year: "2024-25", agency: "Ind-Ra", rating: "A1" },
    { year: "2025-26", agency: "Ind-Ra", rating: "A1" },
    { year: "2026-27", agency: "ICRA", rating: "A1+" },
];

const CreditRatingData = [
    ...CreditRatingLongTerm,
    ...CreditRatingShortTerm,
];

// ── Credit Rating Table Component ───────────────────────────────────────────
const CreditRatingSection = () => (
    <div className="cr-tables-wrapper">
        <div className="cr-table-block">
            <h3 className="cr-table-title">Bank Loan Facilities - Long Term</h3>
            <table className="cr-table">
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Rating Agencies</th>
                        <th>Rating Assigned</th>
                    </tr>
                </thead>
                <tbody>
                    {CreditRatingLongTerm.map((row, i) => (
                        <tr key={i}>
                            <td>{row.year}</td>
                            <td className="cr-agency">{row.agency}</td>
                            <td className="cr-rating">{row.rating}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        <div className="cr-table-block">
            <h3 className="cr-table-title">Bank Loan Facilities - Short Term</h3>
            <table className="cr-table">
                <thead>
                    <tr>
                        <th>Year</th>
                        <th>Rating Agencies</th>
                        <th>Rating Assigned</th>
                    </tr>
                </thead>
                <tbody>
                    {CreditRatingShortTerm.map((row, i) => (
                        <tr key={i}>
                            <td>{row.year}</td>
                            <td className="cr-agency">{row.agency}</td>
                            <td>{row.rating}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);



const ShareHoldingPatternReport = [
    { title: "Quarter ended 2", Quater: "Q2", period: "2026-2027", icon: <PdfIcon />, url: shp_2627_q2 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2026-2027", icon: <PdfIcon />, url: shp_2627_q1 },


    { title: "Quarter ended 4", Quater: "Q4", period: "2025-2026", icon: <PdfIcon />, url: shp_111a },
    { title: "Quarter ended 3", Quater: "Q3", period: "2025-2026", icon: <PdfIcon />, url: shp_111 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2025-2026", icon: <PdfIcon />, url: shp_112 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2025-2026", icon: <PdfIcon />, url: shp_113 },

    { title: "Quarter ended 4", Quater: "Q4", period: "2024-2025", icon: <PdfIcon />, url: shp_114 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2024-2025", icon: <PdfIcon />, url: shp_115 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2024-2025", icon: <PdfIcon />, url: shp_116 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2024-2025", icon: <PdfIcon />, url: shp_117 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2023-2024", icon: <PdfIcon />, url: shp_118 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2023-2024", icon: <PdfIcon />, url: shp_119 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2023-2024", icon: <PdfIcon />, url: shp_120 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2023-2024", icon: <PdfIcon />, url: shp_121 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2022-2023", icon: <PdfIcon />, url: shp_122 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2022-2023", icon: <PdfIcon />, url: shp_123 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2022-2023", icon: <PdfIcon />, url: shp_124 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2022-2023", icon: <PdfIcon />, url: shp_125 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2021-2022", icon: <PdfIcon />, url: shp_126 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2021-2022", icon: <PdfIcon />, url: shp_127 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2021-2022", icon: <PdfIcon />, url: shp_128 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2021-2022", icon: <PdfIcon />, url: shp_129 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2020-2021", icon: <PdfIcon />, url: shp_130 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2020-2021", icon: <PdfIcon />, url: shp_131 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2020-2021", icon: <PdfIcon />, url: shp_132 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2020-2021", icon: <PdfIcon />, url: shp_133 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2019-2020", icon: <PdfIcon />, url: shp_134 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2019-2020", icon: <PdfIcon />, url: shp_135 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2019-2020", icon: <PdfIcon />, url: shp_136 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2019-2020", icon: <PdfIcon />, url: shp_137 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2018-2019", icon: <PdfIcon />, url: shp_138 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2018-2019", icon: <PdfIcon />, url: shp_139 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2018-2019", icon: <PdfIcon />, url: shp_140 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2018-2019", icon: <PdfIcon />, url: shp_141 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2017-2018", icon: <PdfIcon />, url: shp_142 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2017-2018", icon: <PdfIcon />, url: shp_143 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2017-2018", icon: <PdfIcon />, url: shp_144 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2017-2018", icon: <PdfIcon />, url: shp_145 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2016-2017", icon: <PdfIcon />, url: shp_146 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2016-2017", icon: <PdfIcon />, url: shp_147 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2016-2017", icon: <PdfIcon />, url: shp_148 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2016-2017", icon: <PdfIcon />, url: shp_149 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2015-2016", icon: <PdfIcon />, url: shp_150 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2015-2016", icon: <PdfIcon />, url: shp_151 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2015-2016", icon: <PdfIcon />, url: shp_152 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2015-2016", icon: <PdfIcon />, url: shp_153 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2014-2015", icon: <PdfIcon />, url: shp_154 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2014-2015", icon: <PdfIcon />, url: shp_155 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2014-2015", icon: <PdfIcon />, url: shp_156 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2014-2015", icon: <PdfIcon />, url: shp_157 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2013-2014", icon: <PdfIcon />, url: shp_158 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2013-2014", icon: <PdfIcon />, url: shp_159 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2013-2014", icon: <PdfIcon />, url: shp_160 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2013-2014", icon: <PdfIcon />, url: shp_161 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2012-2013", icon: <PdfIcon />, url: shp_162 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2012-2013", icon: <PdfIcon />, url: shp_163 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2012-2013", icon: <PdfIcon />, url: shp_164 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2012-2013", icon: <PdfIcon />, url: shp_165 },
    { title: "Quarter ended 1", Quater: "Q1", period: "2011-2012", icon: <PdfIcon />, url: shp_166 },
    { title: "Quarter ended 2", Quater: "Q2", period: "2011-2012", icon: <PdfIcon />, url: shp_167 },
    { title: "Quarter ended 3", Quater: "Q3", period: "2011-2012", icon: <PdfIcon />, url: shp_168 },
    { title: "Quarter ended 4", Quater: "Q4", period: "2011-2012", icon: <PdfIcon />, url: shp_169 },
];


const UnclaimedDividendData = [
    { title: "2nd 100 Days Campaign – \u201CSaksham Niveshak\u201D", period: "", icon: <PdfIcon />, url: Dividendnew1 },
    { title: "SMART ODR", period: "", icon: <PdfIcon />, url: Dividend33 },
    { title: "100 Days Campaign – \u201CSaksham Niveshak\u201D", period: "", icon: <PdfIcon />, url: Dividend1 },
    { title: "Financial Year ending March 31, 2024", period: "FY 2023-24", icon: <PdfIcon />, url: Dividend2 },
    { title: "Financial Year ending March 31, 2023", period: "FY 2022-23", icon: <PdfIcon />, url: Dividend3 },
    { title: "Financial Year ending March 31, 2022", period: "FY 2021-22", icon: <PdfIcon />, url: Dividend4 },
    { title: "Financial Year ending March 31, 2018 – Interim Dividend", period: "FY 2017-18", icon: <PdfIcon />, url: Dividend5 },
    { title: "Unpaid Dividend_2017-18- List of shareholders whose Interim Dividend is unpaid and unclaimed for FY 2017-18 and is liable to be transferred to IEPF if not claimed.", period: "FY 2017-18", icon: <PdfIcon />, url: Dividend6 },
    { title: "Financial year ending March 31, 2017 – List of shareholders whose Equity Shares are liable to be transferred to IEPF for Interim dividend declared in FY 2017-18.", period: "FY 2017-18", icon: <PdfIcon />, url: Dividend7 },
    { title: "Financial Year ending March 31, 2018", period: "FY 2010-11", icon: <PdfIcon />, url: Dividend8 },
    { title: "Financial Year ending March 31, 2016 – List of Shareholders whose shares are to be transferred to IEFP Authority", period: "2016", icon: <PdfIcon />, url: Dividend9 },
    { title: "Financial Year ending March 31, 2016", period: "FY 2009-10", icon: <PdfIcon />, url: Dividend10 },
    { title: "Financial Year ending March 31, 2015", period: "FY 2010-11", icon: <PdfIcon />, url: Dividend11 },
    { title: "Financial Year ending March 31, 2015", period: "FY 2009-10", icon: <PdfIcon />, url: Dividend12 },
    { title: "Financial Year ending March 31, 2015", period: "FY 2008-09", icon: <PdfIcon />, url: Dividend13 },
    { title: "Financial Year ending March 31, 2014", period: "FY 2010-11", icon: <PdfIcon />, url: Dividend14 },
    { title: "Financial Year ending March 31, 2014", period: "FY 2009-10", icon: <PdfIcon />, url: Dividend15 },
    { title: "Financial Year ending March 31, 2014", period: "FY 2008-09", icon: <PdfIcon />, url: Dividend16 },
    { title: "Financial Year ending March 31, 2014", period: "FY 2007-08", icon: <PdfIcon />, url: Dividend17 },
    { title: "Financial Year ending March 31, 2013", period: "FY 2010-11", icon: <PdfIcon />, url: Dividend18 },
    { title: "Financial Year ending March 31, 2013", period: "FY 2009-10", icon: <PdfIcon />, url: Dividend19 },
    { title: "Financial Year ending March 31, 2013", period: "FY 2008-09", icon: <PdfIcon />, url: Dividend20 },
    { title: "Financial Year ending March 31, 2013", period: "FY 2007-08", icon: <PdfIcon />, url: Dividend21 },
    { title: "Financial Year ending March 31, 2013", period: "FY 2006-07", icon: <PdfIcon />, url: Dividend22 },
    { title: "Financial Year ending March 31, 2012", period: "FY 2010-11", icon: <PdfIcon />, url: Dividend23 },
    { title: "Financial Year ending March 31, 2012", period: "FY 2009-10", icon: <PdfIcon />, url: Dividend24 },
    { title: "Financial Year ending March 31, 2012", period: "FY 2008-09", icon: <PdfIcon />, url: Dividend25 },
    { title: "Financial Year ending March 31, 2012", period: "FY 2007-08", icon: <PdfIcon />, url: Dividend26 },
    { title: "Financial Year ending March 31, 2012", period: "FY 2006-07", icon: <PdfIcon />, url: Dividend27 },
    { title: "Financial Year ending March 31, 2011", period: "FY 2010-11", icon: <PdfIcon />, url: Dividend28 },
    { title: "Financial Year ending March 31, 2011", period: "FY 2009-10", icon: <PdfIcon />, url: Dividend29 },
    { title: "Financial Year ending March 31, 2011", period: "FY 2008-09", icon: <PdfIcon />, url: Dividend30 },
    { title: "Financial Year ending March 31, 2011", period: "FY 2007-08", icon: <PdfIcon />, url: Dividend31 },
    { title: "Financial Year ending March 31, 2011", period: "FY 2006-07", icon: <PdfIcon />, url: Dividend32 },
];

const ResultData = [
    { title: "AGM Results August 8, 2025", period: "2024-2025", icon: <PdfIcon />, url: "https://sequent.in/wp-content/uploads/2025/08/Binder1.pdf" },
    { title: "AGM Results August 30, 2023", period: "2023-2024", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/August%2030,%202023.pdf" },
    { title: "AGM Results September 20, 2022", period: "2022-2023", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/SEIntimationScrutnizerReport.pdf" },
    { title: "AGM Results September 21, 2021", period: "2021-2022", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/SEIntimationVotingResults23092021.pdf" },
    { title: "AGM Results August 25, 2020", period: "2020-2021", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/2020-21_%20August%2025,%202020.pdf" },
    { title: "AGM Results August 29, 2019", period: "2019-2020", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/August%2029,%202019.pdf" },
    { title: "AGM Results September 27, 2018", period: "2018-2019", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/September%2027,%202018.pdf" },
    { title: "AGM Results September 26, 2017", period: "2017-2018", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/BSENSEVotingResults.pdf" },
    { title: "AGM Results September 23, 2016", period: "2016-2017", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/Sequent_Intimation_Reg_44(3)_September_23_2016.pdf" },
    { title: "AGM Results September 24, 2015", period: "2015-2016", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/4_Sequent_AGM_Results_September%2024,%202015.pdf" },
    { title: "AGM Results September 29, 2014", period: "2014-2015", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/agm-result/AGM_Voting%20Results.pdf" },
    { title: "EGM Results July 30, 2015", period: "2015-2016", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/results/EGM%20Results/2015-16/EGM_Results_July%2030,%202015.pdf" },
    { title: "EGM Results March 31, 2015", period: "2014-2015", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/results/EGM%20Results/2014-15/Sequent_EGM%20Result_March%2031,%202015.pdf" },
    { title: "EGM Results March 2, 2015", period: "2014-2015", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/results/EGM%20Results/2014-15/Sequent_EGM%20Result_March%202,%202015.pdf" },
    { title: "EGM Results July 01, 2014", period: "2014-2015", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/egm-result/EGM%20Results_July%201,%202014.pdf" },
    { title: "EGM Results May 21, 2014", period: "2014-2015", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/egm-result/EGM%20Results_May%2021,%202014.pdf" },
    { title: "Postal Ballot Results October 20, 2023", period: "2023-2024", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/October%2020,%202023.pdf" },
    { title: "Postal Ballot Results April 10, 2022", period: "2022-2023", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/SEIntimationVotingResults10042022.pdf" },
    { title: "Postal Ballot Results March 16, 2021", period: "2020-2021", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/SEIntimationVotingResults16032021.pdf" },
    { title: "Postal Ballot Results January 19, 2021", period: "2020-2021", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/PostalBallotVotingResults.pdf" },
    { title: "Postal Ballot Results September 18, 2020", period: "2020-2021", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/SEIntimationPostalBallotVotingResults.pdf" },
    { title: "Postal Ballot Results March 24, 2017", period: "2016-2017", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/SEOutcomePostalBallot.pdf" },
    { title: "Postal Ballot Results February 1, 2016", period: "2015-2016", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/Sequent_Intimation_Reg.%2044(3)_Postal%20Ballot%20Results_February%201,%202016.pdf" },
    { title: "Postal Ballot Results August 2, 2014", period: "2014-2015", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/Sequent_Clause%2035A_Postal%20Ballot%20Results.pdf" },
    { title: "Postal Ballot Results April 23, 2014", period: "2014-2015", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/Postal%20Ballot%20Results_April%2023,%202014.pdf" },
    { title: "Postal Ballot Results December 10, 2013", period: "2013-2014", icon: <PdfIcon />, url: "https://sequent.in/wp-content/pdf/notices/postal-ballot-result/Postal%20Ballot_Voting%20Results_Dec%2010,%202013.pdf" },
];

const ArchiveData = [
    { title: "Board Meeting June 30, 2023", period: "2023-2024", icon: <PdfIcon />, url: arch_237 },
    { title: "Board Meeting September 30, 2023", period: "2023-2024", icon: <PdfIcon />, url: arch_238 },
    { title: "AGM August 30, 2023", period: "2022-2023", icon: <PdfIcon />, url: arch_239 },
    { title: "Board Meeting July 30, 2020", period: "2020-2021", icon: <PdfIcon />, url: arch_240 },
    { title: "Board Meeting September 30, 2020", period: "2020-2021", icon: <PdfIcon />, url: arch_241 },
    { title: "Board Meeting May 14,2019", period: "2019-2020", icon: <PdfIcon />, url: arch_242 },
    { title: "Board Meeting July 31, 2019", period: "2019-2020", icon: <PdfIcon />, url: arch_243 },
    { title: "Board Meeting November 13, 2019", period: "2019-2020", icon: <PdfIcon />, url: arch_244 },
    { title: "Board Meeting January 28, 2020", period: "2019-2020", icon: <PdfIcon />, url: arch_245 },
    { title: "Board Meeting May 24, 2018", period: "2018-2019", icon: <PdfIcon />, url: arch_246 },
    { title: "Board Meeting August 09, 2018", period: "2018-2019", icon: <PdfIcon />, url: arch_247 },
    { title: "Board Meeting Publication in News", period: "2018-2019", icon: <PdfIcon />, url: arch_248 },
    { title: "Board Meeting November 02, 2018", period: "2018-2019", icon: <PdfIcon />, url: arch_249 },
    { title: "Board Meeting February 1, 2019", period: "2018-2019", icon: <PdfIcon />, url: arch_246 },
    { title: "AGM September 26, 2017", period: "2017-2018", icon: <PdfIcon />, url: arch_251 },
    { title: "Court Convened General Meeting November 25, 2017", period: "2017-2018", icon: <PdfIcon />, url: arch_252 },
    { title: "Board Meeting May 23, 2017", period: "2017-2018", icon: <PdfIcon />, url: arch_253 },
    { title: "Board Meeting August 5, 2017", period: "2017-2018", icon: <PdfIcon />, url: arch_254 },
    { title: "Board Meeting November 09, 2017", period: "2017-2018", icon: <PdfIcon />, url: arch_255 },
    { title: "Board Meeting February 9, 2018", period: "2017-2018", icon: <PdfIcon />, url: arch_256 },
    { title: "Board Meeting May 14, 2016", period: "2016-2017", icon: <PdfIcon />, url: arch_257 },
    { title: "Board Meeting August 12, 2016", period: "2016-2017", icon: <PdfIcon />, url: arch_258 },
    { title: "Board Meeting November 10, 2016", period: "2016-2017", icon: <PdfIcon />, url: arch_259 },
    { title: "Board Meeting February 10, 2017", period: "2016-2017", icon: <PdfIcon />, url: arch_260 },
    { title: "Board Meeting February 11, 2016", period: "2015-2016", icon: <PdfIcon />, url: arch_261 },
    { title: "AGM September 23, 2016", period: "2016-2017", icon: <PdfIcon />, url: arch_262 },
    { title: "AGM September 24, 2015", period: "2015-2016", icon: <PdfIcon />, url: arch_263 },
    { title: "EGM July 30, 2015", period: "2015-2016", icon: <PdfIcon />, url: arch_264 },
];

const AmalgamatedCompaniesData = [
    { title: "Q3 FY 2025-26", category: "Business Update", icon: <PdfIcon />, url: BU_Q3_25_26 },
    { title: "Q2 FY 2025-26", category: "Business Update", icon: <PdfIcon />, url: BU_Q2_25_26 },
    { title: "Q1 FY 2025-26", category: "Business Update", icon: <PdfIcon />, url: BU_Q1_25_26 },
    { title: "Q4 FY 2024-25", category: "Business Update", icon: <PdfIcon />, url: BU_Q4_24_25 },
    { title: "Q3 FY 2024-25", category: "Business Update", icon: <PdfIcon />, url: BU_Q3_24_25 },
    { title: "Q2 FY 2024-25", category: "Business Update", icon: <PdfIcon />, url: BU_Q2_24_25 },

    { title: "Index and Annexures - Viyash E Shareholders", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Index_1 },
    { title: "Index and Annexures - Viyash UTC", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Index_2 },
    { title: "Index and Annexures - Appcure Labs UTC", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Index_3 },
    { title: "Index and Annexures - Symed Labs UTC", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Index_4 },
    { title: "Index and Annexures - Geninn E Shareholders", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Index_5 },
    { title: "Signed Symed Final UTC Notice - 28 07 2025", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Signed_1 },
    { title: "Signed Appcure Final UTC Notice - 28 07 2025", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Signed_2 },
    { title: "Signed Viyash Final EGM Notice - 28 07 2025", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Signed_3 },
    { title: "Signed Viyash Final UTC Notice - 28 07 2025", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Signed_4 },
    { title: "Signed Geninn final EGM Notice - 28 07 2025", category: "Merger Notices Index and Annexures", icon: <PdfIcon />, url: Merger_Signed_5 },
];

const Regulation308Data = [];

const DownloadsData = [
    { title: "Form ISR-4", period: "", icon: <PdfIcon />, url: down_isr4 },
    { title: "Form ISR-5", period: "", icon: <PdfIcon />, url: down_isr5 },
    { title: "ISR-1: PAN and KYC Details", period: "", icon: <PdfIcon />, url: down_isr1 },
    { title: "ISR-2: Confirmation of Signature of securities holder by the Banker", period: "", icon: <PdfIcon />, url: down_isr2 },
    { title: "ISR-3: Declaration Form for Opting-out of Nomination by holders of physical securities", period: "", icon: <PdfIcon />, url: down_isr3 },
    { title: "SH-13: Nomination Form", period: "", icon: <PdfIcon />, url: down_sh13 },
    { title: "SH-14: Cancellation or Variation of Nomination", period: "", icon: <PdfIcon />, url: down_sh14 },
];

const MOAData = [
    {
        title: "MOA",
        period: "",
        description: "MOA",
        icon: <PdfIcon />,
        url: moa_1,
    },
    {
        title: "AOA",
        period: "",
        description: "AOA",
        icon: <PdfIcon />,
        url: aoa_1,
    },
];

// ── Main component ─────────
const ShareholderInformation = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("MOA");
    const [selectedYear, setSelectedYear] = useState("All");
    const [selectedQuarter, setSelectedQuarter] = useState("All");

    // Open the correct tab when navigating from an external link with ?tab=
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tabParam = params.get("tab");
        if (tabParam) {
            setActiveTab(tabParam);
            setSelectedYear("All");
            setSelectedQuarter("All");
        }
    }, [location.search]);

    const tabs = [
        { id: "MOA", label: "MOA-AOA", count: MOAData.length },
        { id: "Share price", label: "Share price", count: SharePriceData.length },
        { id: "Credit Rating", label: "Credit Rating", count: CreditRatingData.length },
        { id: "Shareholding Pattern", label: "Shareholding Pattern", count: ShareHoldingPatternReport.length },
        { id: "Dividend", label: "Dividend", count: UnclaimedDividendData.length },
        { id: "Archive", label: "Archive", count: ArchiveData.length },
        { id: "Amalgamated Companies ", label: "Amalgamated Companies ", count: AmalgamatedCompaniesData.length },
        { id: "Downloads", label: "Downloads", count: DownloadsData.length },

    ];

    const getActiveData = () => {
        switch (activeTab) {
            case "MOA": return MOAData;
            case "Share price": return SharePriceData;
            case "Credit Rating": return CreditRatingData;
            case "Shareholding Pattern": return ShareHoldingPatternReport;
            case "Dividend": return UnclaimedDividendData;
            case "Result": return ResultData;
            case "Archive": return ArchiveData;
            case "Amalgamated Companies ": return AmalgamatedCompaniesData;
            case "Regulation 30(8)": return Regulation308Data;
            case "Downloads": return DownloadsData;

            default: return [];
        }
    };

    const activeData = getActiveData();

    const uniqueYears = useMemo(() => {
        const allPeriods = activeData.map(r => r.period).filter(Boolean);
        return ["All", ...Array.from(new Set(allPeriods)).sort().reverse()];
    }, [activeTab, activeData]);

    const uniqueQuarters = ["All", "Q1", "Q2", "Q3", "Q4"];

    // For Dividend tab: no year/quarter filtering – show all files flat under General
    const isDividendTab = activeTab === "Dividend";
    const hasYearFilter = !isDividendTab && activeData.some(r => r.period);
    const hasQuarterFilter = !isDividendTab && activeData.some(r => r.Quater);
    const hasCategoryGrouping = activeData.some(r => r.category);

    const filteredReports = useMemo(() => {
        if (isDividendTab) return activeData; // all Dividend files, no filtering
        return activeData.filter(report => {
            if (!hasYearFilter) return true;
            const yearMatch = selectedYear === "All" || report.period === selectedYear;
            const quarterMatch = !hasQuarterFilter || selectedQuarter === "All" || (report.Quater ? report.Quater === selectedQuarter : true);
            return yearMatch && quarterMatch;
        });
    }, [activeData, selectedYear, selectedQuarter, hasYearFilter, hasQuarterFilter, isDividendTab]);

    const groupedReports = useMemo(() => {
        if (isDividendTab) return null; // Dividend uses a single General block
        if ((!hasYearFilter && !hasCategoryGrouping) || (hasYearFilter && selectedYear !== "All")) return null;

        const groups = {};
        filteredReports.forEach(report => {
            const key = report.period || report.category || "Other";
            if (!groups[key]) groups[key] = [];
            groups[key].push(report);
        });

        if (hasCategoryGrouping) {
            // Keep the order as it appears in the data for categories
            const orderedGroups = [];
            const seen = new Set();
            activeData.forEach(r => {
                if (r.category && !seen.has(r.category)) {
                    seen.add(r.category);
                    if (groups[r.category]) {
                        orderedGroups.push([r.category, groups[r.category]]);
                    }
                }
            });
            return orderedGroups;
        }

        return Object.entries(groups).sort((a, b) => {
            if (a[0] === "Other") return 1;
            if (b[0] === "Other") return -1;
            return b[0].localeCompare(a[0]);
        });
    }, [filteredReports, hasYearFilter, hasCategoryGrouping, selectedYear, activeData, isDividendTab]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setSelectedYear("All");
        setSelectedQuarter("All");
    };

    const getQuarterColor = (quarter) => {
        switch (quarter) {
            case "Q1": return { bg: "#EFF6FF", text: "#2563EB", border: "#BFDBFE" };
            case "Q2": return { bg: "#F0FDF4", text: "#16A34A", border: "#BBF7D0" };
            case "Q3": return { bg: "#FFF7ED", text: "#EA580C", border: "#FED7AA" };
            case "Q4": return { bg: "#FAF5FF", text: "#9333EA", border: "#E9D5FF" };
            default: return { bg: "#F3F4F6", text: "#6B7280", border: "#E5E7EB" };
        }
    };

    return (
        <div className="financial-page">
            {/* HERO */}
            <section className="fin-hero">
                <div className="fin-hero-content">
                    <h1>Shareholder Information</h1>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    {/* <p>Sequent Scientific Limited is India's leading animal health company.</p> */}
                </div>
            </section>

            {/* TABS - STICKY */}
            <div className="fin-tabs-strip">
                <nav className="fin-tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`fin-tab ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => handleTabChange(tab.id)}
                        >
                            <span className="fin-tab-label">{tab.label}</span>
                            {/* <span className="fin-tab-count">{tab.count}</span> */}
                        </button>
                    ))}
                </nav>
            </div>

            {/* CONTENT */}
            <div className="fin-content">
                <div className="fin-content-inner">
                    {/* FILTER BAR */}
                    <div className="fin-filter-bar">
                        <div className="fin-filter-left">
                            <h2 className="fin-section-title">{tabs.find(t => t.id === activeTab)?.label}</h2>
                        </div>

                        {hasYearFilter && !isDividendTab && (
                            <div className="fin-filter-right">
                                <div className="fin-filter-icon">
                                    <FilterIcon />
                                    <span>Filter</span>
                                </div>
                                <div className="fin-select-wrapper">
                                    <CalendarIcon />
                                    <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} className="fin-select">
                                        {uniqueYears.map(year => (
                                            <option key={year} value={year}>{year === "All" ? "All Years" : `FY ${year}`}</option>
                                        ))}
                                    </select>
                                </div>

                                {hasQuarterFilter && (
                                    <div className="fin-select-wrapper">
                                        <select value={selectedQuarter} onChange={(e) => setSelectedQuarter(e.target.value)} className="fin-select">
                                            {uniqueQuarters.map(q => (
                                                <option key={q} value={q}>{q === "All" ? "All Quarters" : q}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ACTIVE FILTERS */}
                    {(selectedYear !== "All" || selectedQuarter !== "All") && hasYearFilter && !isDividendTab && (
                        <div className="fin-active-filters">
                            {selectedYear !== "All" && (
                                <span className="fin-filter-chip">
                                    FY {selectedYear}
                                    <button onClick={() => setSelectedYear("All")}>×</button>
                                </span>
                            )}
                            {selectedQuarter !== "All" && hasQuarterFilter && (
                                <span className="fin-filter-chip">
                                    {selectedQuarter}
                                    <button onClick={() => setSelectedQuarter("All")}>×</button>
                                </span>
                            )}
                            <button className="fin-clear-all" onClick={() => { setSelectedYear("All"); setSelectedQuarter("All"); }}>
                                Clear all
                            </button>
                        </div>
                    )}

                    {/* CREDIT RATING: custom table layout */}
                    {activeTab === "Credit Rating" ? (
                        <CreditRatingSection />
                    ) : isDividendTab ? (
                        /* DIVIDEND: all files under a single General block */
                        <div className="fin-grouped-reports">
                            <div className="fin-report-group">
                                <div className="fin-group-header">
                                    <h3 className="fin-group-title">
                                        <CalendarIcon />
                                        General
                                    </h3>
                                </div>
                                <div className="fin-reports-grid">
                                    {filteredReports.map((report, index) => (
                                        <div key={index} className="fin-report-card">
                                            <div className="fin-card-top">
                                                <div className="fin-card-icon-wrapper">
                                                    {report.icon || <PdfIcon />}
                                                </div>
                                            </div>
                                            <div className="fin-card-body">
                                                <h4 className="fin-card-title">{report.title}</h4>
                                            </div>
                                            <div className="fin-card-footer">
                                                <button
                                                    className="fin-download-btn"
                                                    title="Download"
                                                    onClick={() => report.url && window.open(report.url, "_blank")}
                                                >
                                                    <DownloadIcon />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ) : filteredReports.length > 0 ? (
                        groupedReports && selectedYear === "All" ? (
                            <div className="fin-grouped-reports">
                                {groupedReports.map(([period, reports]) => (
                                    <div key={period} className="fin-report-group">
                                        <div className="fin-group-header">
                                            <h3 className="fin-group-title">
                                                <CalendarIcon />
                                                {period === "Other" ? "General" : (hasCategoryGrouping ? period : `FY ${period}`)}
                                            </h3>
                                            <span className="fin-group-count">{reports.length} file{reports.length !== 1 ? "s" : ""}</span>
                                        </div>
                                        <div className="fin-reports-grid">
                                            {reports.map((report, index) => {
                                                const qColor = getQuarterColor(report.Quater);
                                                return (
                                                    <div key={index} className="fin-report-card">
                                                        <div className="fin-card-top">
                                                            <div className="fin-card-icon-wrapper">
                                                                {report.icon || <PdfIcon />}
                                                            </div>
                                                            {report.Quater && (
                                                                <span className="fin-quarter-badge" style={{ background: qColor.bg, color: qColor.text, borderColor: qColor.border }}>
                                                                    {report.Quater}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="fin-card-body">
                                                            <h4 className="fin-card-title">{report.title}</h4>
                                                        </div>
                                                        <div className="fin-card-footer">
                                                            {report.period && <span className="fin-card-period">{report.period}</span>}
                                                            <button
                                                                className="fin-download-btn"
                                                                title="Download"
                                                                onClick={() => report.url && window.open(report.url, "_blank")}
                                                            >
                                                                <DownloadIcon />
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="fin-reports-grid">
                                {filteredReports.map((report, index) => {
                                    const qColor = getQuarterColor(report.Quater);
                                    return (
                                        <div key={index} className="fin-report-card">
                                            <div className="fin-card-top">
                                                <div className="fin-card-icon-wrapper">
                                                    {report.icon || <PdfIcon />}
                                                </div>
                                                {report.Quater && (
                                                    <span className="fin-quarter-badge" style={{ background: qColor.bg, color: qColor.text, borderColor: qColor.border }}>
                                                        {report.Quater}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="fin-card-body">
                                                <h4 className="fin-card-title">{report.title}</h4>
                                            </div>
                                            <div className="fin-card-footer">
                                                {report.period && <span className="fin-card-period">{report.period}</span>}
                                                <button
                                                    className="fin-download-btn"
                                                    title="Download"
                                                    onClick={() => report.url && window.open(report.url, "_blank")}
                                                >
                                                    <DownloadIcon />
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )
                    ) : (
                        <div className="fin-no-results">
                            <div className="fin-no-results-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 14L15 8M9 8L15 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </div>
                            <h3>No documents found</h3>
                            <p>
                                {activeData.length === 0
                                    ? "Documents for this section will be available soon."
                                    : "Try adjusting your filters to find what you're looking for."}
                            </p>
                            {activeData.length > 0 && (
                                <button className="fin-reset-btn" onClick={() => { setSelectedYear("All"); setSelectedQuarter("All"); }}>
                                    Reset Filters
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ShareholderInformation;